// extracted by mini-css-extract-plugin
export var isPrintedCell = "_x8-1";
export var printerIcon = "_x8-0";